import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { WORK_PHOTOS } from "@/constants/site";
import { useLanguage } from "@/i18n/LanguageContext";

export const Hero = () => {
  const { t } = useLanguage();

  return (
    <section id="top" className="relative min-h-[92vh] flex items-center overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0">
        <img src={WORK_PHOTOS.entrance} alt="Designer entrance by The Build and Design" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/45" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1A1412] via-[#1A1412]/60 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-32 w-full">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="font-hindi text-xl text-[#D4AF37] mb-4"
          data-testid="hero-greeting-hindi"
        >
          {t.hero.greeting}
        </motion.p>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="text-[#D4AF37] tracking-[0.4em] uppercase text-sm mb-6"
          data-testid="hero-eyebrow"
        >
          {t.hero.eyebrow}
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="font-heading text-5xl sm:text-6xl lg:text-7xl text-[#FDFBF7] max-w-3xl leading-[1.05]"
          data-testid="hero-headline"
        >
          {t.hero.headlineA}<span className="text-[#D4AF37]">{t.hero.headlineB}</span>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-8 max-w-xl text-[#B8A99A] text-base md:text-lg leading-relaxed"
          data-testid="hero-subcopy"
        >
          {t.hero.sub}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.45 }}
          className="mt-12 flex flex-wrap gap-5"
        >
          <a
            href="#contact"
            data-testid="hero-cta-button"
            className="group flex items-center gap-3 bg-[#D4AF37] text-[#1A1412] px-8 py-4 text-sm tracking-widest uppercase font-semibold hover:bg-[#E5C15D] transition-colors duration-300"
          >
            {t.hero.cta}
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
          <a
            href="#work"
            data-testid="hero-work-button"
            className="flex items-center gap-3 border border-[#FDFBF7]/40 text-[#FDFBF7] px-8 py-4 text-sm tracking-widest uppercase hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-300"
          >
            {t.hero.work}
          </a>
        </motion.div>
      </div>
    </section>
  );
};
